var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTrophyi = function SvgTrophyi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M21.19 5.8h-2.85V4.38a1.62 1.62 0 0 0 .85-1.42 1.58 1.58 0 0 0-1.56-1.57H6.43a1.6 1.6 0 0 0-1.64 1.57 1.62 1.62 0 0 0 .85 1.42v1.35H2.81a1.54 1.54 0 0 0-1.42 1.5v3.42a3.15 3.15 0 0 0 3.12 3.13h2.84a6.13 6.13 0 0 0 3.12 1.85v3.84h-.85a1.57 1.57 0 0 0 0 3.14h4.68a1.57 1.57 0 0 0 0-3.14h-.85v-3.84a6.34 6.34 0 0 0 3.2-1.85h2.83a3.11 3.11 0 0 0 3.12-3.13V7.23a1.34 1.34 0 0 0-1.4-1.43zM4.5 11.15a.49.49 0 0 1-.5-.5V8.43h1.63V9.5a6 6 0 0 0 .22 1.64zM15.7 9.5a3.76 3.76 0 0 1-3.68 3.7 3.47 3.47 0 0 1-2.63-1.14A3.67 3.67 0 0 1 8.34 9.5V4.59h7.38zm4.34 1.14a.49.49 0 0 1-.5.5H18.2a6 6 0 0 0 .21-1.64V8.44h1.64z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrophyi);
export default ForwardRef;